import { useEffect } from 'react';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';

const PageViewTracker = () => {
  const sendDataToGTM = useGTMDispatch();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const affi_id = urlParams.get('affi_id');
    const site = urlParams.get('site');
    
    sendDataToGTM({
      event: 'page_view',
      page_location: window.location.href,
      page_path: window.location.pathname + window.location.search,
      page_title: document.title,
    });
  }, []);
  
  return null;
};

export default PageViewTracker;